import React, { useState, useEffect } from "react";
import { authService } from "../../auth";
import { Link, NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import uuid from "react-uuid";
import AuthModalComponent from "../../LoginExtra/AuthModalComponent";
import CommonHashTagsPhoto from "./Common/CommonHashTagsPhoto";

function HashTagsPhotos(props) {
  const [userData, setUserData] = useState(authService.getUserDetailsFromLocalStorage())
  const [loginSuccess] = useState(authService.isAuthenticated());
  const [loginRequired, setLoginRequired] = useState(false);

  const loginRequiredFunc = () => {
    setLoginRequired(true);
    window.$("#loginModal").modal("show");
  }

  const handleLoginClose = () => {
    setLoginRequired(false);
    window.$("#loginModal").modal("hide");
  }

  return (
    <div id="hashTagPhotos" className="expHashSection expHashPhotos">
      <h2 className="edtrdsk">Photos</h2>
      <div className="explLatarticle">
        <OwlCarousel
          id={"expHashPhotosCarousel"}
          className={"expHashPhotosCarousel"}
          autoWidth={true}
          nav={false}
          dots={false}
          margin={12}
          key={uuid()}
          items={3}
          loop={false}
          rewind={true}
        >
          {props.imageListData &&
            props.imageListData.slice(0, 3).map((item, idx) => {
              return (
                <div className="item" key={idx}>
                  <CommonHashTagsPhoto item={item} key={item.id} idx={idx} />
                </div>);
            })
          }
        </OwlCarousel>

        {props.imageListData && props.imageListData.length > 3 &&
          <div className="btnblock text-center">
            {(props.hashTagType === 'global' ? 
                (<Link className="btn morebtnsm" to={"/explore-hashtag/photos/" + props.tagName}>View All</Link>) : 
              props.hashTagType === "COMMUNITY" ? 
                (<Link className="btn morebtnsm" to={"/community/hashtag/photos/" + props.tagName + "/" + props.userName}>View All</Link>) :
                (<Link className="btn morebtnsm" to={"/profile-hashtag/photos/" + props.tagName + "/" + props.userName}>View All</Link>)

            )}
          </div>
        }
        {loginRequired === true ? (
          <AuthModalComponent handleLoginClose={handleLoginClose} pathname={"/explore-hashtag/photos/" + props.tagName} />
        ) : null}


      </div>
    </div>
  )
}

export default HashTagsPhotos;
